(() => {
  const nav = document.querySelector('[data-page-menu]');
  if (!nav) return;

  const detailsEls = Array.from(nav.querySelectorAll('.page-menu__details'));

  // Only one submenu open at a time
  detailsEls.forEach((d) => {
    d.addEventListener('toggle', () => {
      if (!d.open) return;
      detailsEls.forEach((other) => {
        if (other !== d) other.open = false;
      });
    });
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (nav.contains(e.target)) return;
    detailsEls.forEach((d) => (d.open = false));
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    detailsEls.forEach((d) => (d.open = false));
  });
})();
